import '../plugins/anchorsPlugin';


// initialize smooth anchor links
export default  function initAnchors() {
	var offset = $('header').outerHeight();
	if ($('#wpadminbar').length > 0)
		offset += $('#wpadminbar').outerHeight();
	$('a.anchors[href*="#"]').smoothscroll({
		duration:  500,
		offset: (offset * -1),
		hash: true,});
}